import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@app/App';
import { applyThemeMode, type ThemeMode } from '@core/designsystem';
import { readOneOf } from '@core/settings/preferences';
import { telemetry } from '@core/telemetry';
import { installLastResort } from '@app/lastResort';
import '@core/designsystem';

/*
 * Последний рубеж ставится **до всего остального**.
 *
 * Строки ниже — тема, счётчик, монтирование React — сами могут упасть, и тогда ловить
 * их будет уже некому: экран останется белым, каким его и увидели 15.09.2026.
 */
installLastResort();

/**
 * Выбранная тема применяется **до** первого кадра.
 *
 * Иначе она включалась только при заходе в настройки: юрист выбирал тёмную, закрывал
 * приложение, и оно открывалось светлым. Поймано прогоном 05.09.2026 — тест смотрел
 * на `data-theme` у документа после перезапуска.
 */
applyThemeMode(readOneOf<ThemeMode>('theme', ['system', 'light', 'dark'], 'system'));

/*
 * Запуск приложения. Здесь, а не в компоненте: `StrictMode` в разработке монтирует
 * дерево дважды, и любой счётчик в эффекте считал бы каждый запуск за два. Загрузка
 * страницы случается ровно один раз.
 *
 * Возвращение к свёрнутому приложению — тоже запуск, но об этом знает `DailyStats`:
 * на iPhone страница живёт днями, и загрузкой это не поймать.
 */
telemetry.record('appOpened');

const root = document.getElementById('root');
if (!root) throw new Error('Нет корневого элемента: index.html не тот, что ожидается.');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
